import { Masonry } from 'masonic';

import styles from './styles.module.css';
import type { TestimonialOrNews } from '../../View/NewsTestimonialsView/NewsTestimonialView';
import type { DITSLink } from '@redturtle/qubicaamf-theme/components/Blocks/Listing/DiveInTheSector/Slides';
import MasonryCard from './MasonryCard';
import LoadMorePagination from './LoadMorePagination';
import { Loader } from 'semantic-ui-react';

export type MasonryItemProps = TestimonialOrNews & DITSLink;

interface MasonryProps {
  loadMore: () => void;
  totalItems: number;
  loading: boolean;
  items: MasonryItemProps[];
}

const MasonryTemplate = ({
  loadMore,
  totalItems,
  loading,
  items,
}: MasonryProps) => {
  return (
    <>
      <Masonry
        items={items}
        render={MasonryCard}
        maxColumnCount={3}
        columnGutter={20}
      />
      {loading && (
        <div className={styles.loaderContainer}>
          <Loader active />
        </div>
      )}
      {totalItems > items.length && (
        <div className={styles.loadMoreContainer}>
          <LoadMorePagination loadMore={loadMore} />
        </div>
      )}
    </>
  );
};
export default MasonryTemplate;
